/**
 * Register the PWA service worker in production only. We skip localhost /
 * Vercel preview deploys so a stale shell can't mask a broken preview build.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (!import.meta.env.PROD) return;

  const host = window.location.hostname;
  const isPreview = host.endsWith('vercel.app');
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  if (isPreview || isLocal) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Never fatal — the app just loses offline-shell caching.
      console.warn('[sw] register failed:', err);
    });
  });
}
